import IColumnData from "../../../../common/interface/IColumnData";

export const COMPOSICION_COLUMN = (isAdmin: boolean): IColumnData[] => [
  {
    width: 100,
    label: "NRO. DOCUMENTO",
    dataKey: "documento",
  },
  ...(isAdmin
    ? [
        {
          width: 80,
          label: "CLIENTE",
          dataKey: "clienteId",
        },
      ]
    : []),
  {
    width: 60,
    label: "TIPO DE DOCUMENTO",
    dataKey: "tipo",
  },
  {
    width: 20,
    label: "DATA DE EMISSÃO",
    dataKey: "fechaEmision",
    sortable: true,
  },
  {
    width: 40,
    label: "SALDO",
    dataKey: "importe",
    numeric: true,
  },
  {
    width: 40,
    label: "VENCIMENTO",
    dataKey: "vencimiento",
    sortable: true,
  },
  {
    width: 40,
    label: "PARCELA",
    dataKey: "parcela",
  },
  {
    width: 40,
    label: "DATA DE ATUALIZAÇÃO",
    dataKey: "fechaActualizacion",
  },
  {
    width: 20,
    label: "DOWNLOAD",
    dataKey: "tienePdf",
    boolean: true,
  },
];
